module.exports = __webpack_public_path__ + "img/chevron-back.0179890a.svg";